import React, { useEffect, useState } from 'react';
import icon from '../app-icon.png';
import { track as trackEvent } from '../analytics';

// iOS UL handoff requires a real <a> tap to a UL-claimed host. The page
// itself sits on www.demodeck.com (not in the applinks set), so the link
// must point at open.demodeck.com — a cross-domain user-initiated tap is
// what triggers iOS to hand off to the installed app.
function OpenInAppBanner() {
    const [show, setShow] = useState(false);
    const [openUrl, setOpenUrl] = useState('');

    useEffect(() => {
        const ua = navigator.userAgent || '';
        const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
        if (!isIOS) return;
        if (sessionStorage.getItem('openInAppDismissed') === '1') return;
        setOpenUrl(`https://open.demodeck.com${window.location.pathname}${window.location.search}`);
        setShow(true);
    }, []);

    if (!show) return null;

    const onDismiss = (e) => {
        e.stopPropagation();
        e.preventDefault();
        sessionStorage.setItem('openInAppDismissed', '1');
        setShow(false);
    };

    return (
        <div className="open-in-app-banner">
            <button className="open-in-app-dismiss" onClick={onDismiss} aria-label="Dismiss">
                ×
            </button>
            <img src={icon} alt="" className="open-in-app-icon" />
            <div className="open-in-app-text">
                <div className="open-in-app-title">Demodeck</div>
                <div className="open-in-app-subtitle">Listen in the app</div>
            </div>
            <a
                className="open-in-app-cta"
                href={openUrl}
                onClick={() => trackEvent('install_cta_clicked', { surface: 'share_banner' })}
            >Open</a>
        </div>
    );
}

export default OpenInAppBanner;
